<template
  ><div style="padding-top:-2px;margin-top:-2px;">
    <v-label
      ><b>{{ label }}</b></v-label
    >
    <s-select-generic
      autocomplete  
      class="text"
      :itemtext="itemtext"
      :itemvalue="itemvalue"
      :disabled="disabled"
      :value="item"
      id="CardCode"
      :return-object="returnObject"
      @input="updateValue"
      :config="config"
      :full="full"
      :text="text"
      :clearable="clearable"
      :noDefault="clearable"
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sService from "@/services/Sale/SleCriteriaCollectionService.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
       noDefault: {
      type: Boolean,
      default: false,
    },    
    full: {
      type: Boolean,
      default: false,
    },
    itemtext: {
      type: String,
      default: "CardName"
    },
    itemvalue: {
      type: String,
      default: "CardCode"
    }
  },
  watch: {
    value(newVal) {
      console.log("Nuevo valor", newVal);
      if (newVal && this.items.length > 0) {
        const found = this.items.find(
          i => i[this.itemvalue] === newVal[this.itemvalue]
        );
        this.item = found || newVal;
      } else {
        this.item = newVal;
      }
    }
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
    updateValue(val) {
      this.item = val;
      console.log("updateValue", val);
      this.$emit("input", val);
    }
  },
  data: () => ({
    item: null,
    val: "",
    items: [],
    config: {},
  }),

  created() {
    this.item = this.value;
    this.config = {      
      url: _sService.GetUrlclient(),
      title: this.label,
      params: { search:'',requestID: this.$fun.getUserID() },
    };
  },
};
</script>